/* eslint-disable react/prop-types */ // TODO: add props
import Immutable from 'immutable';
import 'core/bootstrap';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route, Switch } from 'react-router-dom';
import { browserHistory } from 'edrolo/utils/browserHistory';
import urlResolver from 'edrolo/utils/URLResolver';
import scrollToTop from 'edrolo/utils/scrollToTop';
import configureStore from './configureStore';
import { trackPageVisitHoc } from 'edrolo/analytics';
import { LessonDemo } from 'edrolo/domains/lessons-chunkview/components/LessonDemo';
import { QuestionSetPageDemo } from 'edrolo/domains/exams';
import { pageErrorBoundaryHoc } from 'edrolo/domains/app/hoc';
import { StrictMode } from 'react';

const staticDemoProfile = Immutable.fromJS({
  'user_id': 1,
  'profile_id': 1,
  'display_name': 'Demo User',
  'first_name': 'Demo',
  'last_name': 'User',
  'email': 'demo.user@edrolo.com.au.test',
  'school': 'Demo School',
  'is_teacher': false,
  'is_staff': false,
  'is_poc': false,
  'school_classes': {},
  'keystore': {},
  'staff_permissions': {},
});

const store = configureStore({
  profile: staticDemoProfile,
});

const PageHOC = (pageName, Component, origin) => {
  const ComponentPage = (props) => <Component {...props} />;

  return trackPageVisitHoc(
    pageName,
    pageErrorBoundaryHoc(ComponentPage),
    origin
  );
};

const DemoLessonPageRoute = PageHOC('Demo Lesson', LessonDemo);
const DemoLessonChunkPageRoute = PageHOC('Demo Lesson Chunk', LessonDemo);

const DemoQuestionSetIndexPageRoute = PageHOC(
  'Demo Question Set Index',
  QuestionSetPageDemo
);
const DemoQuestionSetQuestionPageRoute = PageHOC(
  'Demo Question Set Question',
  QuestionSetPageDemo
);

ReactDOM.render(
  <StrictMode>
    <Provider store={store}>
      <Router onUpdate={scrollToTop} history={browserHistory}>
        <Switch>
          <Route
            exact
            path={urlResolver.getPath('demo-chunkview-lesson')}
            render={(routerProps) => (
              <DemoLessonPageRoute
                lessonId={routerProps.match.params.lessonId}
                activeChunkIndex={routerProps.match.params.index}
                replace={routerProps.history.replace}
                push={routerProps.history.push}
              />
            )}
          />
          <Route
            exact
            path={urlResolver.getPath('demo-chunkview-chunk')}
            render={(routerProps) => (
              <DemoLessonChunkPageRoute
                lessonId={routerProps.match.params.lessonId}
                activeChunkIndex={routerProps.match.params.index}
                replace={routerProps.history.replace}
                push={routerProps.history.push}
              />
            )}
          />

          <Route
            exact
            path={urlResolver.getPath('demo-question-set-index')}
            render={(routerProps) => {
              const searchParams = new URLSearchParams(
                routerProps.location.search
              );
              return (
                <DemoQuestionSetIndexPageRoute
                  examId={routerProps.match.params.examId}
                  questionId={routerProps.match.params.questionId}
                  searchParams={searchParams}
                  {...routerProps}
                />
              );
            }}
          />
          <Route
            exact
            path={urlResolver.getPath('demo-question-set-question')}
            render={(routerProps) => {
              const searchParams = new URLSearchParams(
                routerProps.location.search
              );
              return (
                <DemoQuestionSetQuestionPageRoute
                  examId={routerProps.match.params.examId}
                  questionId={routerProps.match.params.questionId}
                  searchParams={searchParams}
                  {...routerProps}
                />
              );
            }}
          />
        </Switch>
      </Router>
    </Provider>
  </StrictMode>,
  document.getElementById('lug')
);
